import type { AgentShop } from '../../types';
import { Button, Modal } from '@kioskgaming/ui';

export type ShopConfirmModalState = { type: 'suspend'; shop: AgentShop };

interface ShopGovernanceModalProps {
  state: ShopConfirmModalState | null;
  onClose: () => void;
  busyShopId: string | null;
  onConfirmSuspend: (shopId: string) => Promise<boolean>;
}

export default function ShopGovernanceModal({
  state,
  onClose,
  busyShopId,
  onConfirmSuspend,
}: ShopGovernanceModalProps) {
  if (!state) return null;

  const busy = busyShopId === state.shop.id;

  return (
    <Modal
      isOpen
      onClose={onClose}
      variant="confirm"
      title="Suspend this Shop?"
      subtitle={
        <>
          {state.shop.name}
          <span className="font-normal text-muted-foreground"> · {state.shop.email}</span>
        </>
      }
      footer={
        <div className="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end sm:gap-3">
          <Button type="button" variant="outline" disabled={busy} onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            disabled={busy}
            loading={busy}
            onClick={async () => {
              const id = state.shop.id;
              const ok = await onConfirmSuspend(id);
              if (ok) onClose();
            }}
            className="bg-amber-600 text-white hover:bg-amber-700"
          >
            Suspend Shop
          </Button>
        </div>
      }
      closeOnOverlayClick={!busy}
      preventClose={busy}
    >
      <div
        className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-950"
        role="alert"
      >
        <p className="font-semibold text-amber-900">Warning</p>
        <p className="mt-1 text-amber-900/90">
          The Shop will be blocked from signing in and operating until you reactivate it. Active sessions may stop
          working.
        </p>
      </div>
    </Modal>
  );
}
